<template>
  <div class="kanban-day-summary" aria-label="Resumo do dia">
    <span
      v-for="item in items"
      :key="item.key"
      class="kanban-day-summary__item"
      :class="`kanban-day-summary__item--${item.key}`"
    >
      <v-icon small class="mr-1">{{ item.icon }}</v-icon>
      <strong class="mr-1">{{ item.value }}</strong>
      {{ item.value === 1 ? item.singular : item.plural }}
    </span>
  </div>
</template>

<script>
/**
 * Histórico do kanban — os totais de um dia passado, ao lado do título.
 *
 * Conta a partir dos MESMOS eventos que montam as colunas: o resumo e o
 * quadro nunca discordam.
 */
export default {
  name: "KanbanDaySummary",

  props: {
    events: { type: Array, default: () => [] },
  },

  computed: {
    items() {
      const count = (status) =>
        this.events.filter((event) => event.status === status).length;

      return [
        {
          key: "total",
          icon: "mdi-calendar-text",
          value: this.events.length,
          singular: "consulta",
          plural: "consultas",
        },
        {
          key: "concluded",
          icon: "mdi-check-circle",
          value: count("concluded"),
          singular: "atendida",
          plural: "atendidas",
        },
        {
          key: "no-show",
          icon: "mdi-account-off",
          value: count("no_show"),
          singular: "falta",
          plural: "faltas",
        },
        {
          key: "canceled",
          icon: "mdi-close-circle",
          value: count("canceled"),
          singular: "cancelada",
          plural: "canceladas",
        },
      ];
    },
  },
};
</script>

<style scoped>
.kanban-day-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.kanban-day-summary__item {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 0.82rem;
  white-space: nowrap;
  border: 1px solid var(--ds-blue-100);
  background: var(--ds-blue-50);
}

.kanban-day-summary__item--total .v-icon {
  color: var(--ds-primary);
}

.kanban-day-summary__item--concluded .v-icon {
  color: #2e7d32;
}

.kanban-day-summary__item--no-show .v-icon {
  color: #546e7a;
}

.kanban-day-summary__item--canceled .v-icon {
  color: #e53935;
}
</style>
